import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useCuentas } from "../../../settings/hooks/useSettings";
import { useMultimoneda } from "../../../../shared/hooks/useMultimoneda";
import apiFetch from "../../../../shared/services/apiClient";
import { formatCurrency } from "../../../../shared/utils/formatCurrency";
import { C, Label, Btn, Toast } from "../../../settings/components/SettingsUI";

const MONEDAS       = ["CRC","USD","EUR"];
const EMPTY_CUENTA  = {banco:"",numero_cuenta:"",iban:"",moneda:"CRC",saldo:"0"};
const MONEDA_COLOR  = {CRC:"#f97316",USD:"#4ade80",EUR:"#60a5fa"};
const MONEDA_SYMBOL = {CRC:"₡",USD:"$",EUR:"€"};

export default function CuentasBancariasPage() {
  const { cuentas, loading, create, remove, update } = useCuentas();
  const multimoneda = useMultimoneda();
  const [form,setForm]=useState(EMPTY_CUENTA);
  const [sinRelBancos, setSinRelBancos] = useState(false);
  useEffect(()=>{
    apiFetch("/api/core/relaciones-catalogo/").then(r=>r.json()).then(d=>{
      setSinRelBancos(!d.relaciones?.rel_cuenta_bancos?.cuenta_actual);
    }).catch(()=>{});
  },[]);
  const [editId,setEditId]=useState(null);
  const [editForm,setEditForm]=useState(EMPTY_CUENTA);
  const [adding,setAdding]=useState(false);
  const [toast,setToast]=useState({msg:"",type:""});
  const [usdBlockAlert,setUsdBlockAlert]=useState(false);
  const [usdEditBlockAlert,setUsdEditBlockAlert]=useState(false);
  const [deleteConfirm,setDeleteConfirm]=useState(null); // cuenta a eliminar | null
  const [deleting,setDeleting]=useState(false);

  const showToast=(msg,type="success")=>{setToast({msg,type});setTimeout(()=>setToast({msg:"",type:""}),3500);};

  const inputSt={background:"rgba(255,255,255,0.06)",border:`1px solid ${C.border}`,
    borderRadius:8,padding:"9px 12px",color:"#f1f5f9",
    fontSize:"0.85rem",outline:"none",width:"100%",boxSizing:"border-box"};

  return (
    <div>
      <span style={{color:"#9ca3af"}}>
        <Link to="/"><span style={{color:"#9ca3af"}}>Inicio </span></Link>/ <span>Cuentas Bancarias</span>
      </span>
      <h2 className="mt-2 me-2 p-0 title">Cuentas Bancarias</h2>
      <p className="mb-3" style={{color:"var(--text-muted)"}}>
        Cuentas bancarias registradas para conciliación, traslados y pagos.
      </p>

      <div style={{background:C.bg2,border:`1px solid ${C.border}`,borderRadius:14,overflow:"hidden"}}>
        <div style={{padding:"22px 24px"}}>
          <Toast msg={toast.msg} type={toast.type}/>
          {sinRelBancos && (
            <div style={{display:"flex",alignItems:"flex-start",gap:10,
              background:"rgba(251,191,36,0.08)",border:"1px solid rgba(251,191,36,0.3)",
              borderRadius:9,padding:"11px 14px",marginBottom:16}}>
              <i className="fa-solid fa-triangle-exclamation" style={{color:"#fbbf24",marginTop:2,flexShrink:0}}/>
              <div>
                <p style={{margin:"0 0 3px",color:"#fbbf24",fontWeight:700,fontSize:"0.82rem"}}>
                  Relación de Bancos sin configurar
                </p>
                <p style={{margin:0,color:"#94a3b8",fontSize:"0.76rem"}}>
                  No podrás registrar cuentas bancarias hasta asignar la cuenta padre de{" "}
                  <strong style={{color:"#fbbf24"}}>Bancos</strong> en{" "}
                  <Link to="/settings?tab=relaciones" style={{color:"#f97316",fontWeight:700}}>Relaciones Contables</Link>.
                </p>
              </div>
            </div>
          )}
          <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
            <Btn onClick={()=>{setAdding(a=>!a);setForm(EMPTY_CUENTA);}} variant={adding?"ghost":"primary"}>
              <i className={`fa-solid fa-${adding?"xmark":"plus"}`}/>{adding?"Cancelar":"Nueva cuenta"}
            </Btn>
          </div>

          {adding && (
            <div style={{background:C.bg1,border:`1px solid rgba(249,115,22,0.2)`,borderRadius:10,padding:18,marginBottom:16}}>
              <p style={{margin:"0 0 14px",fontWeight:600,color:C.text,fontSize:"0.85rem",display:"flex",alignItems:"center",gap:8}}>
                <i className="fa-solid fa-building-columns" style={{color:C.accent}}/>Nueva cuenta bancaria
              </p>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))",gap:12,marginBottom:14}}>
                <div><Label required>Banco</Label>
                  <input style={inputSt} placeholder="Ej: Banco Nacional" value={form.banco}
                    onChange={e=>setForm(f=>({...f,banco:e.target.value}))}/></div>
                <div><Label required>N° Cuenta</Label>
                  <input style={inputSt} placeholder="Número de cuenta" value={form.numero_cuenta}
                    onChange={e=>setForm(f=>({...f,numero_cuenta:e.target.value}))}/></div>
                <div><Label>IBAN</Label>
                  <input style={inputSt} placeholder="Ej: CR21015201001026284066" value={form.iban}
                    maxLength={34} onChange={e=>setForm(f=>({...f,iban:e.target.value.toUpperCase()}))}/></div>
                <div><Label>Moneda</Label>
                  <select style={inputSt} value={form.moneda} onChange={e=>{setForm(f=>({...f,moneda:e.target.value}));if(e.target.value==='CRC')setUsdBlockAlert(false);}}>
                    {MONEDAS.map(m=><option key={m}>{m}</option>)}</select></div>
                <div><Label>Saldo inicial</Label>
                  <input style={inputSt} type="number" value={form.saldo}
                    onChange={e=>setForm(f=>({...f,saldo:e.target.value}))}/></div>
              </div>
              {usdBlockAlert && (
                <div style={{display:"flex",alignItems:"flex-start",gap:10,
                  background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.28)",
                  borderLeft:"3px solid #ef4444",borderRadius:8,padding:"10px 14px",marginBottom:12,
                  color:"#fca5a5",fontSize:"0.83rem",lineHeight:1.55}}>
                  <i className="fa-solid fa-triangle-exclamation" style={{color:"#f87171",flexShrink:0,marginTop:2}}/>
                  <span style={{flex:1}}>
                    Para registrar cuentas en <strong style={{color:"#f87171"}}>{form.moneda}</strong>, primero debés activar{" "}
                    <strong style={{color:"#f87171"}}>Soporte Multimoneda (USD)</strong> en{" "}
                    <Link to="/settings" style={{color:"#f87171",fontWeight:700}}>Configuración</Link>.
                  </span>
                  <button type="button" onClick={()=>setUsdBlockAlert(false)}
                    style={{background:"none",border:"none",color:"#f87171",cursor:"pointer",padding:0,flexShrink:0,fontSize:"0.85rem"}}>
                    <i className="fa-solid fa-xmark"/>
                  </button>
                </div>
              )}
              <div style={{display:"flex",justifyContent:"flex-end"}}>
                <Btn disabled={sinRelBancos} onClick={async()=>{
                  if(sinRelBancos){showToast("Configurá primero la relación de Bancos en Relaciones Contables.","error");return;}
                  if(!multimoneda && form.moneda!=='CRC'){setUsdBlockAlert(true);return;}
                  setUsdBlockAlert(false);
                  try{await create(form);setForm(EMPTY_CUENTA);setAdding(false);showToast("Cuenta creada");}catch(e){showToast(e.message,"error");}
                }}>
                  <i className="fa-solid fa-floppy-disk"/>Guardar cuenta
                </Btn>
              </div>
            </div>
          )}

          {loading ? <div style={{textAlign:"center",padding:32,color:C.muted}}><i className="fa-solid fa-circle-notch fa-spin" style={{color:C.accent,marginRight:8}}/>Cargando…</div>
          : cuentas.length===0 ? <div style={{textAlign:"center",padding:40,color:C.muted}}>
              <i className="fa-solid fa-building-columns" style={{fontSize:"2rem",display:"block",marginBottom:10,opacity:0.2}}/>
              <p style={{margin:0,fontSize:"0.85rem"}}>No hay cuentas registradas.</p></div>
          : <div style={{display:"flex",flexDirection:"column",gap:8}}>
              {cuentas.map(c=>{
                const mc=MONEDA_COLOR[c.moneda]??C.accent;
                return (
                  <div key={c.id} style={{display:"flex",flexDirection:"column",gap:0}}>
                  <div style={{
                    background:C.bg1,
                    border:`1px solid ${deleteConfirm?.id===c.id ? "rgba(239,68,68,0.4)" : C.border}`,
                    borderRadius: deleteConfirm?.id===c.id ? "10px 10px 0 0" : 10,
                    overflow:"hidden",
                    transition:"border-color 0.15s",
                  }}
                    onMouseOver={e=>{ if(deleteConfirm?.id!==c.id) e.currentTarget.style.borderColor="rgba(249,115,22,0.2)"; }}
                    onMouseOut={e=>{ if(deleteConfirm?.id!==c.id) e.currentTarget.style.borderColor=C.border; }}>
                    {editId===c.id?(
                      <div style={{padding:16}}>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))",gap:10,marginBottom:12}}>
                          <div><Label>Banco</Label><input style={inputSt} value={editForm.banco} onChange={e=>setEditForm(f=>({...f,banco:e.target.value}))}/></div>
                          <div><Label>N° Cuenta</Label><input style={inputSt} value={editForm.numero_cuenta} onChange={e=>setEditForm(f=>({...f,numero_cuenta:e.target.value}))}/></div>
                          <div><Label>IBAN</Label><input style={inputSt} value={editForm.iban||""} maxLength={34} placeholder="Ej: CR21..." onChange={e=>setEditForm(f=>({...f,iban:e.target.value.toUpperCase()}))}/></div>
                          <div><Label>Moneda</Label><select style={inputSt} value={editForm.moneda} onChange={e=>{setEditForm(f=>({...f,moneda:e.target.value}));if(e.target.value==='CRC')setUsdEditBlockAlert(false);}}>{MONEDAS.map(m=><option key={m}>{m}</option>)}</select></div>
                          <div><Label>Saldo</Label><input style={inputSt} type="number" value={editForm.saldo} onChange={e=>setEditForm(f=>({...f,saldo:e.target.value}))}/></div>
                        </div>
                        {usdEditBlockAlert && editId===c.id && (
                          <div style={{display:"flex",alignItems:"flex-start",gap:10,
                            background:"rgba(239,68,68,0.08)",border:"1px solid rgba(239,68,68,0.28)",
                            borderLeft:"3px solid #ef4444",borderRadius:8,padding:"10px 14px",marginBottom:12,
                            color:"#fca5a5",fontSize:"0.83rem",lineHeight:1.55}}>
                            <i className="fa-solid fa-triangle-exclamation" style={{color:"#f87171",flexShrink:0,marginTop:2}}/>
                            <span style={{flex:1}}>
                              Para usar moneda <strong style={{color:"#f87171"}}>{editForm.moneda}</strong>, primero debés activar{" "}
                              <strong style={{color:"#f87171"}}>Soporte Multimoneda (USD)</strong> en{" "}
                              <Link to="/settings" style={{color:"#f87171",fontWeight:700}}>Configuración</Link>.
                            </span>
                            <button type="button" onClick={()=>setUsdEditBlockAlert(false)}
                              style={{background:"none",border:"none",color:"#f87171",cursor:"pointer",padding:0,flexShrink:0,fontSize:"0.85rem"}}>
                              <i className="fa-solid fa-xmark"/>
                            </button>
                          </div>
                        )}
                        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                          <Btn small variant="ghost" onClick={()=>{setEditId(null);setUsdEditBlockAlert(false);}}>Cancelar</Btn>
                          <Btn small onClick={async()=>{
                            if(!multimoneda && editForm.moneda!=='CRC'){setUsdEditBlockAlert(true);return;}
                            setUsdEditBlockAlert(false);
                            try{await update(c.id,editForm);setEditId(null);showToast("Cuenta actualizada");}catch(e){showToast(e.message,"error");}
                          }}>
                            <i className="fa-solid fa-floppy-disk"/>Guardar
                          </Btn>
                        </div>
                      </div>
                    ):(
                      <div style={{padding:"14px 18px",display:"flex",alignItems:"center",gap:14,flexWrap:"wrap"}}>
                        <div style={{width:42,height:42,borderRadius:10,flexShrink:0,background:`${mc}14`,border:`1px solid ${mc}28`,display:"flex",alignItems:"center",justifyContent:"center"}}>
                          <i className="fa-solid fa-building-columns" style={{color:mc,fontSize:"1rem"}}/>
                        </div>
                        <div style={{flex:1,minWidth:160}}>
                          <div style={{fontWeight:700,color:C.text,fontSize:"0.9rem"}}>{c.banco}</div>
                          <div style={{color:C.muted,fontSize:"0.78rem",fontFamily:"monospace",marginTop:2,display:"flex",flexWrap:"wrap",alignItems:"center",gap:6}}>
                            {c.numero_cuenta}
                            {c.iban&&<span style={{color:"#94a3b8",fontSize:"0.72rem",fontFamily:"monospace",display:"inline-flex",alignItems:"center",gap:4}}>
                              <i className="fa-solid fa-landmark" style={{fontSize:"0.6rem"}}/>IBAN: {c.iban}</span>}
                            <span style={{padding:"1px 7px",borderRadius:4,background:`${mc}18`,color:mc,fontSize:"0.68rem",fontWeight:700}}>{c.moneda}</span>
                          </div>
                        </div>
                        <div style={{display:"flex",alignItems:"center",gap:8,flexShrink:0,marginLeft:"auto"}}>
                          <div style={{textAlign:"right",marginRight:4}}>
                            <div style={{fontWeight:700,color:C.text,fontSize:"0.92rem",fontFamily:"monospace"}}>{MONEDA_SYMBOL[c.moneda]??c.moneda}{formatCurrency(Number(c.saldo))}</div>
                            <div style={{fontSize:"0.68rem",color:C.muted,marginTop:1}}>saldo actual</div>
                          </div>
                          <div style={{display:"flex",gap:6,flexShrink:0}}>
                            <Btn small variant="ghost" onClick={()=>{setEditId(c.id);setEditForm({banco:c.banco,numero_cuenta:c.numero_cuenta,iban:c.iban||"",moneda:c.moneda,saldo:c.saldo});}}>
                              <i className="fa-solid fa-pencil"/>
                            </Btn>
                            <Btn small variant="danger" onClick={()=>{ setDeleteConfirm(c); setEditId(null); }}>
                              <i className="fa-solid fa-trash"/>
                            </Btn>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* ── Panel de confirmación de borrado ── */}
                  {deleteConfirm?.id===c.id && (
                    <div style={{
                      background:"rgba(239,68,68,0.07)",
                      border:"1px solid rgba(239,68,68,0.35)",
                      borderTop:"none",
                      borderRadius:"0 0 10px 10px",
                      padding:"14px 18px",
                    }}>
                      <div style={{display:"flex",gap:10,alignItems:"flex-start",marginBottom:12}}>
                        <i className="fa-solid fa-triangle-exclamation"
                           style={{color:"#f87171",fontSize:"1rem",marginTop:2,flexShrink:0}}/>
                        <div style={{fontSize:"0.84rem",color:C.text,lineHeight:1.55}}>
                          <strong style={{color:"#f87171"}}>¿Eliminar la cuenta "{c.banco}"?</strong><br/>
                          <span style={{color:C.muted,fontSize:"0.79rem"}}>
                            Esta acción no se puede deshacer. Si tiene movimientos o recibos vinculados,
                            la cuenta puede estar bloqueada.
                          </span>
                        </div>
                      </div>
                      <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                        <button type="button"
                          onClick={()=>setDeleteConfirm(null)}
                          disabled={deleting}
                          style={{padding:"7px 16px",borderRadius:7,fontSize:"0.82rem",fontWeight:600,
                            cursor:"pointer",border:`1px solid ${C.border}`,
                            background:"transparent",color:C.muted,opacity:deleting?0.5:1}}>
                          Cancelar
                        </button>
                        <button type="button"
                          disabled={deleting}
                          onClick={async()=>{
                            setDeleting(true);
                            try{
                              await remove(c.id);
                              setDeleteConfirm(null);
                              showToast("Cuenta eliminada");
                            }catch(e){
                              showToast(e.message,"error");
                            }finally{
                              setDeleting(false);
                            }
                          }}
                          style={{padding:"7px 18px",borderRadius:7,fontSize:"0.82rem",fontWeight:700,
                            cursor:deleting?"not-allowed":"pointer",
                            border:"1px solid rgba(239,68,68,0.4)",
                            background:"rgba(239,68,68,0.15)",color:"#f87171",
                            display:"inline-flex",alignItems:"center",gap:7,
                            opacity:deleting?0.6:1}}>
                          {deleting
                            ? <><i className="fa-solid fa-circle-notch fa-spin"/>Eliminando…</>
                            : <><i className="fa-solid fa-trash"/>Sí, eliminar</>}
                        </button>
                      </div>
                    </div>
                  )}
                  </div>
                );
              })}
            </div>}
        </div>
      </div>
    </div>
  );
}
